import React from "react";
import {
    BrowserRouter, generatePath, Navigate, Route, Routes,
} from "react-router-dom";
import Layout from "./components/layout/layout";
import Policy from "./components/pages/policy/policy";
import PrivatePolicy from "./components/pages/policy/privatePolicy/privatePolicy";
import UserContent from "./components/pages/policy/userContent/userContent";
import DetailedTerms from "./components/pages/rules/detailedTerms";
import ExplainWords from "./components/pages/rules/explainWords";
import GeneralTerms from "./components/pages/rules/generalTerms";
import Introduce from "./components/pages/rules/introduce";
import Rules from "./components/pages/rules/rules";
import { RouterConfig } from "./config";
import Map4dUIConfig from "./map4dUI/components/map4dUIConfig/map4dUIConfig";
import { createConfig } from "./map4dUI/tools";

const config = createConfig({
    paginationTable: {
        images: {
            loading: "",
            empty: ""
        }
    }
})
const App = () => {
    return (
        <Map4dUIConfig config={config}>
            <BrowserRouter>
                <Routes>
                    <Route
                        path={RouterConfig.home.route}
                        element={<Layout />}
                    >
                        <Route index element={<Navigate to={RouterConfig.policy.route} />} />

                        <Route path={RouterConfig.policy.route} element={<Policy />}>
                            <Route index element={<Navigate to={RouterConfig.policy.private.route} />} />
                            <Route path={RouterConfig.policy.private.route} element={<PrivatePolicy />} />
                            <Route path={RouterConfig.policy.useContent.route} element={<UserContent />} />
                        </Route>

                        <Route path={RouterConfig.rules.route} element={<Rules />} >
                            <Route index element={<Navigate to={RouterConfig.rules.introduce.route} />} />
                            <Route path={RouterConfig.rules.introduce.route} element={<Introduce />} />
                            <Route path={RouterConfig.rules.explainWords.route} element={<ExplainWords />} />
                            <Route path={RouterConfig.rules.generalTerms.route} element={<GeneralTerms />} />
                            <Route path={RouterConfig.rules.detailedTerms.route} element={<DetailedTerms />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter >
        </Map4dUIConfig>
    )
}
export default App;